import { Account } from '@/domain/usecases'
import { UserRefundProgram } from '@/domain/usecases/refund/user-refund-program'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs } from 'react-router-dom'
import RegisteredPlanBaseLoader from '../registered-plan-base-loader'

export default class RefundRequestLoader extends RegisteredPlanBaseLoader {
  private static readonly PROGRAM_ID_PATH_PARAM_NAME = 'id'

  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient)
  }

  async loader({ params }: LoaderFunctionArgs) {
    const id = params[RefundRequestLoader.PROGRAM_ID_PATH_PARAM_NAME] ?? ''

    return this.defer({
      data: Promise.all([
        super.importRemoteModule('makeRemoteAccountProfile').then(async makeRemote => {
          const remote = makeRemote(this.queryClient) as Account
          return remote.loader()
        }),
        super.importRemoteModule('makeRemoteUserRefundProgram').then(async makeRemote => {
          const remote = makeRemote(this.queryClient) as UserRefundProgram
          return remote.get(id)
        })
      ]).then(([accountProfile, program]) => ({
        accountProfile,
        program
      }))
    })
  }
}
